import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { motion } from 'framer-motion';

const DisabledService = ({ serviceName, isHebrew = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to home after 5 seconds
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const messages = {
    calculator: {
      en: {
        title: "Pricing Calculator Temporarily Unavailable",
        message: "We're enhancing our pricing calculator to provide you with better features and more accurate estimates. Thank you for your patience.",
        redirect: "You'll be redirected to the homepage in a few seconds..."
      },
      he: {
        title: "מחשבון העלות אינו זמין כרגע",
        message: "אנחנו משפרים את מחשבון העלות שלנו כדי לספק לכם תכונות טובות יותר והערכות מדויקות יותר. תודה על הסבלנות.",
        redirect: "תועברו לעמוד הבית בעוד כמה שניות..."
      }
    },
    platform: {
      en: {
        title: "Platform Temporarily Unavailable",
        message: "We're upgrading our platform to deliver an enhanced user experience. We'll be back soon with exciting new features.",
        redirect: "You'll be redirected to the homepage in a few seconds..."
      },
      he: {
        title: "הפלטפורמה אינה זמינה כרגע",
        message: "אנחנו משדרגים את הפלטפורמה שלנו כדי לספק חוויית משתמש משופרת. נחזור בקרוב עם תכונות חדשות ומרגשות.",
        redirect: "תועברו לעמוד הבית בעוד כמה שניות..."
      }
    }
  };

  const currentService = serviceName === 'calculator' ? 'calculator' : 'platform';
  const lang = isHebrew ? 'he' : 'en';
  const content = messages[currentService][lang];

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center',
      background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
      direction: isHebrew ? 'rtl' : 'ltr'
    }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '3rem',
                boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                border: '1px solid #e5e7eb'
              }}
            >
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                style={{
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 2rem auto'
                }}
              >
                <i className="las la-tools" style={{ fontSize: '2rem', color: 'white' }}></i>
              </motion.div>

              <motion.h1
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
                style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  marginBottom: '1.5rem'
                }}
              >
                {content.title}
              </motion.h1>

              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
                style={{
                  fontSize: '1.2rem',
                  color: '#6b7280',
                  lineHeight: '1.6',
                  marginBottom: '2rem'
                }}
              >
                {content.message}
              </motion.p>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
                style={{
                  padding: '1rem',
                  background: '#f9fafb',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  marginBottom: '2rem'
                }}
              >
                <p style={{ 
                  margin: 0, 
                  color: '#6b7280', 
                  fontSize: '0.9rem',
                  fontStyle: 'italic'
                }}>
                  {content.redirect}
                </p>
              </motion.div>

              <motion.button
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/', { replace: true })}
                style={{
                  background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                {isHebrew ? 'חזור לעמוד הבית' : 'Go to Homepage'}
                <i className={`las ${isHebrew ? 'la-arrow-left' : 'la-arrow-right'} ms-2`}></i>
              </motion.button>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DisabledService;
